import React, { Component } from 'react';
import RecapContainer from '../../containers/recapContainer';

class CaptionsRecap extends Component {
  renderPause() {
    return (
      <div>
        <p>Drat! *snaps*</p>
        <p>The speaker is broken on this monitor! Were you still able to understand the videos?</p>
        <p>Check out the screen of the person across from you. Notice anything different about their videos?</p>
      </div>
      )
  }

  renderRecap() {
    return (
      <div>
        <p>Have you ever tried to watch the news in a loud airport or bar?</p>
        <p>
          Closed captioning benefits everyone, especially the Deaf and Hard-of-Hearing community.
        </p>
      </div>
    );
  }

  render() {
    return (
      <RecapContainer
      	title='Closed Captioning'
      	nextLabel='Continue to Step 3'
      	nextFunc={this.props.nextFunc}
        pause={this.renderPause()}
        recap={this.renderRecap()}
      />
    );
  }
}

export default CaptionsRecap;



// WEBPACK FOOTER //
// ./src/steps/captions/recap.js